import { useRouter } from "next/router";

import HeadSeo from "@components/HeadSeo/HeadSeo";
import Container from "@ui-kit/Container/Container";
import { addBlankAttrToHtml } from "@utils/utils";

import s from "./PrivacyPolicy.module.scss";

const PrivacyPolicy = ({ data }) => {
  const { locale } = useRouter();

  const { article } = data;

  let seo = {
    et: {
      title: "Privaatsuspoliitika",
      description: "Privaatsuspoliitika",
      socialTitle: "Privaatsuspoliitika",
      socialDescription: "Privaatsuspoliitika",
      pageKeywords: "",
      thumbnail:
        "/static/images/thumbnails/privacy-policy/Lux_Express_privacy_policy.jpg",
    },
    en: {
      title: "Confientiality policy",
      description: "Confientiality policy",
      socialTitle: "Confientiality policy",
      socialDescription: "Confientiality policy",
      pageKeywords: "",
      thumbnail:
        "/static/images/thumbnails/privacy-policy/Lux_Express_privacy_policy.jpg",
    },
    lt: {
      title: "Privatumo politika",
      description: "Privatumo politika",
      socialTitle: "Privatumo politika",
      socialDescription: "Privatumo politika",
      pageKeywords: "",
      thumbnail:
        "/static/images/thumbnails/privacy-policy/Lux_Express_privacy_policy.jpg",
    },
    lv: {
      title: "Privātuma politika.",
      description: "Privātuma politika",
      socialTitle: "Privātuma politika.",
      socialDescription: "Privātuma politika",
      pageKeywords: "",
      thumbnail:
        "/static/images/thumbnails/privacy-policy/Lux_Express_privacy_policy.jpg",
    },
    ru: {
      title: "Политика конфиденциальности",
      description: "Политика конфиденциальности",
      socialTitle: "Политика конфиденциальности",
      socialDescription: "Политика конфиденциальности",
      pageKeywords: "",
      thumbnail:
        "/static/images/thumbnails/privacy-policy/Lux_Express_privacy_policy.jpg",
    },
    pl: {
      title: "Confientiality policy",
      description: "Confientiality policy",
      socialTitle: "Confientiality policy",
      socialDescription: "Confientiality policy",
      pageKeywords: "",
      thumbnail:
        "/static/images/thumbnails/privacy-policy/Lux_Express_privacy_policy.jpg",
    },
  };

  seo = seo[locale];
  seo.articlePublishedTime = article?.createdAt || "";
  seo.articleModifiedTime = article?.editedAt || "";

  return (
    <div className={s.privacyPolicy}>
      <HeadSeo seo={seo} />
      <Container>
        <Container full={false}>
          <section>
            <h1 className={s.title}>{article.title}</h1>
            {article.body && (
              <div
                className={s.article}
                dangerouslySetInnerHTML={{
                  __html: addBlankAttrToHtml(article.body),
                }}
              />
            )}
          </section>
        </Container>
      </Container>
    </div>
  );
};

export default PrivacyPolicy;
